module.exports = ".main-details .main-section {\n  margin-bottom: 20px; }\n\napp-touchspin {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 80% !important; }\n\n.btn-touchspin {\n  right: 5px;\n  position: absolute; }\n\n#inversionista-selector .select-inv-primary {\n  font-weight: 500; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas.component.scss
// module id = ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas.component.scss
// module chunks = main